import { WhatsappLogo } from "@phosphor-icons/react";
import { useSettings } from "../hooks/usePublicContent";

export const WhatsAppFab = () => {
  const s = useSettings();
  return (
    <a
      href={`https://wa.me/${s.whatsapp}?text=${encodeURIComponent("Ciao! Vorrei informazioni sui tuoi servizi.")}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
      aria-label="Contattami su WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
};
